import config from '../../../config';

export const adyenConfig = Object.freeze({
    environment: config.adyen.env,
    clientKey: config.adyen.key,
    analytics: {
        enabled: true // Set to false to not send analytics data to Adyen.
    }
});

export const PAYMENT_METHODS = Object.freeze({
    fpx: {
        container: 'molpay_ebanking_fpx_MY',
        configuration: {}
    },
    applepay: {
        container: 'applepay',
        configuration: {}
    }
});
